"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var useSlider_1 = __importDefault(require("../useSlider"));
var SliderButton_1 = __importDefault(require("../SliderButton"));
var SliderNav = function (props) {
    var _a = props.htmlElement, Tag = _a === void 0 ? 'div' : _a, prevButtonProps = props.prevButtonProps, nextButtonProps = props.nextButtonProps, _b = props.showCounter, showCounter = _b === void 0 ? false : _b, _c = props.counter, _d = _c === void 0 ? {} : _c, _e = _d.htmlElement, CounterTag = _e === void 0 ? 'div' : _e, counterID = _d.id, counterRest = __rest(_d, ["htmlElement", "id"]), rest = __rest(props, ["htmlElement", "prevButtonProps", "nextButtonProps", "showCounter", "counter"]);
    var _f = (0, useSlider_1.default)(), currentSlideIndex = _f.currentSlideIndex, slides = _f.slides, setIsPaused = _f.setIsPaused, pauseOnHover = _f.pauseOnHover;
    var slideRef = (0, react_1.useRef)(null);
    return (react_1.default.createElement(Tag, __assign({ ref: slideRef }, rest, { onMouseEnter: function () {
            if (pauseOnHover)
                setIsPaused(true);
        }, onMouseLeave: function () {
            if (pauseOnHover)
                setIsPaused(false);
        } }),
        react_1.default.createElement(SliderButton_1.default, __assign({ direction: "prev" }, prevButtonProps)),
        showCounter && (react_1.default.createElement(CounterTag, __assign({ id: counterID }, counterRest), "".concat(currentSlideIndex + 1, " / ").concat(slides.length))),
        react_1.default.createElement(SliderButton_1.default, __assign({ direction: "next" }, nextButtonProps))));
};
exports.default = SliderNav;
//# sourceMappingURL=index.js.map